// frontend/src/askos/TodayStudyPlanCard.js
//
// Today's Study Plan — real data from GET /tenant/{slug}/askos/study-plan/today.
// If the student has no active plan yet, offers a "Generate" CTA instead of
// showing fabricated illustrative rows.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStudyPlanToday, updateStudyPlanItem, generateStudyPlan } from '../api/studyPlanApi';

const TodayStudyPlanCard = ({ slug }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [generating, setGenerating] = useState(false);
    const navigate = useNavigate();

    const load = () => {
        setLoading(true);
        getStudyPlanToday(slug).then(setData).catch(() => setData(null)).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

    const toggleItem = async (item) => {
        const nextStatus = item.status === 'completed' ? 'pending' : 'completed';
        setData(d => ({
            ...d,
            items: d.items.map(i => i.id === item.id ? { ...i, status: nextStatus } : i),
            completed: d.completed + (nextStatus === 'completed' ? 1 : -1),
        }));
        try {
            await updateStudyPlanItem(slug, item.id, { status: nextStatus });
        } catch {
            load(); // reconcile on failure
        }
    };

    const handleGenerate = async () => {
        setGenerating(true);
        try {
            await generateStudyPlan(slug);
            load();
        } catch {
            setGenerating(false);
        }
    };

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Today's Study Plan</h3>
                {data?.has_active_plan && <a href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/study-plan'); }}>View Plan</a>}
            </div>

            {loading && <p className="empty-note">Loading…</p>}

            {!loading && !data?.has_active_plan && (
                <>
                    <p className="coming-soon">No active study plan yet. Generate one based on your weakest topics.</p>
                    <button type="button" className="primary-btn" onClick={handleGenerate} disabled={generating}>
                        {generating ? 'Generating…' : 'Generate My Study Plan'}
                    </button>
                </>
            )}

            {!loading && data?.has_active_plan && (
                <>
                    <p className="empty-note" style={{ marginBottom: 10 }}>{data.completed}/{data.total} Completed</p>
                    {data.items.length === 0 && <p className="empty-note">Nothing scheduled for today.</p>}
                    {data.items.map(item => (
                        <div key={item.id} className="study-row">
                            <div className={`status${item.status === 'completed' ? ' done' : ''}`} onClick={() => toggleItem(item)} style={{ cursor: 'pointer' }}>
                                {item.status === 'completed' && '✓'}
                            </div>
                            <div className="study-info">
                                <strong>{item.title}</strong>
                                {item.source_label && <span>{item.source_label}</span>}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </article>
    );
};

export default TodayStudyPlanCard;
